import { STUDYGROUP_MEMBERSHIP_STATUS_MEMBER } from "@/constants";

const isNumericIdentifier = (value: unknown): boolean => {
  if (typeof value === "number") {
    return Number.isFinite(value);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed !== "" && Number.isFinite(Number(trimmed));
  }
  return false;
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};

export const streamKeys = {
  searchAuthorMembers: (studyGroupId: number | null) =>
    [
      "streamSearchAuthorMembers",
      studyGroupId,
      STUDYGROUP_MEMBERSHIP_STATUS_MEMBER,
    ] as const,
  isPostsKey: (queryKey: readonly unknown[]): boolean => {
    if (queryKey.length === 1) return true;
    if (queryKey.length === 2) {
      const second = queryKey[1];
      if (second === "list") return true;
      return isNumericIdentifier(second);
    }
    if (queryKey.length === 3 && typeof queryKey[1] === "string") {
      const segment = queryKey[1];
      if (["list", "detail", "comments", "comment"].includes(segment)) {
        return isNumericIdentifier(queryKey[2]);
      }
    }
    return false;
  },
  isPinnedPostsKey: (queryKey: readonly unknown[]): boolean => {
    if (queryKey.length === 1) return true;
    if (queryKey.length === 2) return queryKey[1] === "list";
    if (queryKey.length >= 3 && queryKey[1] === "list") {
      return queryKey[2] === "none" || isNumericIdentifier(queryKey[2]);
    }
    return false;
  },
  isActivitiesKey: (queryKey: readonly unknown[]): boolean => {
    if (queryKey.length === 1) return true;
    if (queryKey.length === 2) return isPlainObject(queryKey[1]);
    return false;
  },
  isPostDetailKey: (queryKey: readonly unknown[]): boolean => {
    if (queryKey.length === 1) return true;
    if (queryKey.length === 2) return isNumericIdentifier(queryKey[1]);
    return false;
  },
  isFavoritePostsKey: (queryKey: readonly unknown[]): boolean => {
    if (queryKey.length === 1) return true;
    if (queryKey.length === 2) return queryKey[1] === "list";
    return false;
  },
};
